import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["timeline", "scrollable"]

  connect() {
    this.setWidth()
    window.addEventListener("resize", this.setWidth)
  }

  disconnect() {
    window.removeEventListener("resize", this.setWidth)
  }

  setWidth = () => {
    if (this.hasTimelineTarget && this.hasScrollableTarget) {
      const width = this.scrollableTarget.scrollWidth
      this.timelineTarget.style.width = `${width - 364}px`
    }
  }
}
